var _style, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _defs, _defs2, _defs3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTnd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 141.7 141.7",
    style: {
      enableBackground: "new 0 0 141.7 141.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:none;}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{fill:url(#SVGID_2_);}\r\n\t.st4{clip-path:url(#SVGID_4_);}\r\n\t.st5{clip-path:url(#SVGID_6_);}\r\n\t.st6{fill:url(#SVGID_9_);}\r\n\t.st7{fill:url(#SVGID_10_);}\r\n\t.st8{fill:url(#SVGID_11_);}\r\n\t.st9{fill:url(#SVGID_12_);}\r\n\t.st10{fill:url(#SVGID_13_);}\r\n\t.st11{fill:url(#SVGID_14_);}\r\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 25.9992,
    y1: 70.7134,
    x2: 120.0226,
    y2: 70.7134
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01364815,
    style: {
      stopColor: "#2B317F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1283,
    style: {
      stopColor: "#29265B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2299,
    style: {
      stopColor: "#2B317F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2457,
    style: {
      stopColor: "#2B307C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3906,
    style: {
      stopColor: "#292964"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4799,
    style: {
      stopColor: "#29265B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    style: {
      stopColor: "#29285E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5173,
    style: {
      stopColor: "#273067"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5306,
    style: {
      stopColor: "#253C76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5427,
    style: {
      stopColor: "#234E8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554,
    style: {
      stopColor: "#1F65A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5586,
    style: {
      stopColor: "#1D70B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5971,
    style: {
      stopColor: "#2B317F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7482,
    style: {
      stopColor: "#2F2C7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8575,
    style: {
      stopColor: "#29265B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8888,
    style: {
      stopColor: "#292B62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9339,
    style: {
      stopColor: "#293875"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9873,
    style: {
      stopColor: "#294D94"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#29539D"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "26,70.5 73.6,23 120,69.7 73.6,118.4 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "36,70.9 74.2,32.7 111.4,70.2 74.2,109.3 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "35.5,70.3 73.7,32.1 110.9,69.6 73.7,108.7 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 46.1347,
    y1: 71.0068,
    x2: 100.307,
    y2: 71.0068
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01364815,
    style: {
      stopColor: "#2B317F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09855705,
    style: {
      stopColor: "#29265B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2299,
    style: {
      stopColor: "#2B317F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2457,
    style: {
      stopColor: "#2B307C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3906,
    style: {
      stopColor: "#292964"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4799,
    style: {
      stopColor: "#29265B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5023,
    style: {
      stopColor: "#29285E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5178,
    style: {
      stopColor: "#273067"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5313,
    style: {
      stopColor: "#253C76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    style: {
      stopColor: "#234E8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    style: {
      stopColor: "#1F65A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5597,
    style: {
      stopColor: "#1D70B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5971,
    style: {
      stopColor: "#2B317F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7482,
    style: {
      stopColor: "#2F2C7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8575,
    style: {
      stopColor: "#29265B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9056,
    style: {
      stopColor: "#29336E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#29539D"
    }
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "46.1,70.8 73.6,23 100.3,70 73.6,119 "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "48.6,70.7 73.4,27.5 97.6,69.9 73.4,114.1 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    d: "M53.2,71.9c-0.8-11.6,8.4-21.6,19.7-21.8c11.5-0.2,20.6,9.9,20.2,21.1c-0.4,10.3-8.7,19.3-19.2,19.6 C63.3,91.3,54,82.9,53.2,71.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_5_",
    x: 49.4,
    y: 46.3,
    width: 47.5,
    height: 48.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_7_",
    x: 49.4,
    y: 46.3,
    width: 47.5,
    height: 48.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_8_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 100,
    height: 102,
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAlgCWAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAMTAAAEbgAABw3/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAGgAZgMBIgACEQEDEQH/ xAC1AAACAwEBAQAAAAAAAAAAAAAAAwIEBgUBBwEAAgMBAAAAAAAAAAAAAAAAAgMAAQQFEAACAQQC AwEAAwEAAAAAAAABAgARAwQFEgYQIRMVICIUBxEAAgECAgUGCwgDAAAAAAAAAQIDEQQAITFBURIT IDBhcZEiEIGhscEyQlJywgXR8YKSQ1M0FaIUJBIAAAQEBAQHAAAAAAAAAAAAAAERISAxQQIQoRKC UWGBIkBx4TKiE2P/2gAMAwEAAhEDEQAAAPoAEhX5WAcOp4XIgy+nb4biDY6b5dYg/VDPaHK0AGzj 9X5i8a0J+701oWUpKDISGnNQxoT2+DnR/WSgc9/NwWly25bvU+MW1EUptnqRZWvUzaMg9aXeOQCX ZzmsytSMWeQay7MEWuM/AtthdrQqPrPXxRaLvaYT6v8AOcl0IWY6U01XFKOoOiJysV3NF3sHtrrG uMTb3L6hlP5lDdYzo46inrOV1vULlzi2ylvF6TKQBlMAkFBcz/HDZnpMAy6unDK20AmwCT//2gAI AQIAAQUAluwzD5qIFWHHVg6MhmPa5sRGEEWXbYdeLTHHG2WjvOUUwT5+7JrbaFfZBrbEAnqYr1BE KzjEFJUAf6RVWKm1eW4CJSD1L9/kPArW3/poftLv28//2gAIAQMAAQUAhYSsYz6EQMCI7UFYGhMI iVBrGFSRAspKeKwn2SIDDCZylZdqJyitKwiUnCEAh7bIQYvhVp5NKH5VXjBTz//aAAgBAQABBQDz m5+HgWth/wBBVTkdx7BfI7HvS+P2rfWjg96uVwNng7FP47/s1jWDNysrNvMspFEURRLF69j3ND2Z c1vPYt2NVjOWdisZIVgEWLBORB6vvTn2pcuJat7LYXdjmykZYw8KYrQNC8xcy7iZP6+P+R3TNOPq g0DTlHcR3haBorTnORlZg5pfqvfr5OfynKF49yNcnKBopg9ykAli78rXevp+1Kwkx6yhJf8AqFMt iKsCTjOM77YIz+ECGMkZJwpHWsVPdpYi+gs4yzY+lvuWCcnVi3PmIyRkjJCkCy2KRDB4wsTj1u5b S7b2OufX5nGMsZIyRllIsUwGYuPdy8j8rG/Km91C7LGuW3tuRGWMsZYR4UxSSer6JsC153Ohs7IZ eHk4d0xowjDxjY9/Ju9e6qmAf45GLj5VvN6bZeX+qbq2W6/ujLXUt7eOF0IVwdbg6+35/9oACAEC AgY/AApsQkJEG7TyCXFgp+22FK0MSrp6gubxb9eQt8osgdh0coVML+uraiArimQ4XVKDRZKp8cWn yDpv9A315jvVMsf/2gAIAQMCBj8AgdwpeHWLanUGR1HLjAp4uG+IqGx//9oACAEBAQY/APDxryZY U1FjmehVGZ8WCn0623qHKWc0B/Amf+WD/wBPCU+zGirTx0LeXAc301QKetl+XRj+UXFalXVWr2rX AW/tww9+HI/kc59oxv2kocjNk0OvWpz5Rt7ek17rX2Y6626ejDT3UjSytpZtmwDQB0DlLLC5jkXN WU0OFtL2iXJySQZLIdlNTefkBIiDdzV4QOe6Nbkeb78F3JZmNWY5kk6zzFRkRoODaXT1u4hVWOmR NvxDX9/geWQhY4wWdjoCqKk4kupdLmiLqVR6qjmo7mE0kiYMtdGWo9Bx/bZ8HhcTd119zr3ssCBT R7pwh1dxe83oHOfU7FzXgtFJH8LyoGHiI8uLWDOiRFxs77Ffk5y4T9+MR9kkcnyYXf8AV4CcPR6t W+avO2s+dHiKDZ3GLfPzk70rwYw/VV0T5sCdRV7Vw/4G7reg859RvG0yNFGnUkiE9pPkw0Ug3kcF XU6CCKEYktnzCmsbH2kPqnmo7aEVklYKuzPWegY/q/0eHub1M97Tv9e93vBVMrmKpiPvbUPXho5F KupoynIgjmKDMnQMf7d0tLuUUCH9NDq+I6+zkcWMiK6AoH9l9gennwYbmMxuMxXQRtB0HlLDbxtL K3qogqcLd31JLsZogzSI+lvNq28oxXEayodTCvZswWspjGfck7y+Jhn58dyJZhnmjrq+PdOP4cnY PtwKwCJTnvSOo8gJbyYDfULmo/bgHzuPRjh2cKxDWRmzfExzPI//2Q==",
    transform: "matrix(0.48 0 0 0.48 48.96 46.08)"
  })))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M53.2,71.9c-0.8-11.6,8.4-21.6,19.7-21.8c11.5-0.2,20.6,9.9,20.2,21.1c-0.4,10.3-8.7,19.3-19.2,19.6 C63.3,91.3,54,82.9,53.2,71.9z"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M56.1,71.9C55.3,61.5,63.8,52.2,74,52.6C83.4,53,91,61.7,90.5,71.6c-0.5,8.9-7.6,16.2-16.2,16.7 C65,88.8,56.8,81.3,56.1,71.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 58.0841,
    y1: 77.2011,
    x2: 88.8571,
    y2: 77.2011
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04189944,
    style: {
      stopColor: "#29265B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06560032,
    style: {
      stopColor: "#282C62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1012,
    style: {
      stopColor: "#253D77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1441,
    style: {
      stopColor: "#215898"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.176,
    style: {
      stopColor: "#1D70B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    style: {
      stopColor: "#1E6CB1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1976,
    style: {
      stopColor: "#215696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.219,
    style: {
      stopColor: "#244480"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.244,
    style: {
      stopColor: "#26376F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2749,
    style: {
      stopColor: "#282D64"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3182,
    style: {
      stopColor: "#29285D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4385,
    style: {
      stopColor: "#29265B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5154,
    style: {
      stopColor: "#29285D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    style: {
      stopColor: "#282D64"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5628,
    style: {
      stopColor: "#26376F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5787,
    style: {
      stopColor: "#244480"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5924,
    style: {
      stopColor: "#215696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6042,
    style: {
      stopColor: "#1E6CB1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6061,
    style: {
      stopColor: "#1D70B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9218,
    style: {
      stopColor: "#2B317F"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M58.1,74.8l4.9,0.1c0,0,0.8,7,9.5,7.4c0,0,7.8,0.8,11.8-7.4c0,0,0.7-1.6,0.8-2.7h-8.6l-0.1-3.8l12.1,0 c0,0,1.7,4.4-2.3,10.6c0,0-4.8,7.1-13.5,7C72.7,86,62.5,85.6,58.1,74.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 75.8855,
    y1: 77.7446,
    x2: 105.6198,
    y2: 77.7446
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#29265B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.002793296,
    style: {
      stopColor: "#29265B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.009835915,
    style: {
      stopColor: "#29285E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01473542,
    style: {
      stopColor: "#273067"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0189848,
    style: {
      stopColor: "#253C76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02286293,
    style: {
      stopColor: "#234E8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02645615,
    style: {
      stopColor: "#1F65A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02793296,
    style: {
      stopColor: "#1D70B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03497607,
    style: {
      stopColor: "#2061A9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04761992,
    style: {
      stopColor: "#254C96"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06171849,
    style: {
      stopColor: "#283D89"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07827621,
    style: {
      stopColor: "#2A3481"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1034,
    style: {
      stopColor: "#2B317F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2706,
    style: {
      stopColor: "#2B317F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5971,
    style: {
      stopColor: "#2B317F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7482,
    style: {
      stopColor: "#2F2C7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8575,
    style: {
      stopColor: "#29265B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8895,
    style: {
      stopColor: "#292960"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9283,
    style: {
      stopColor: "#29346F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9704,
    style: {
      stopColor: "#294487"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#29539D"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M58.8,75.8l4.1,0c0,0,2.1,6.8,10.4,7.2c0,0,7.4,0.8,11.3-7.4c0,0,0.7-1.3,0.8-3.4h-8.9l-0.1-3h11.9 c0,0,1.3,4-2.5,10.2c0,0-4.2,6.8-12.6,6.7C73.3,86.2,62.5,85.7,58.8,75.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 58.3171,
    y1: 66.3668,
    x2: 86.0555,
    y2: 66.3668
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1D70B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007834644,
    style: {
      stopColor: "#1E6CB1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01724298,
    style: {
      stopColor: "#2060A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02745893,
    style: {
      stopColor: "#234C8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03818141,
    style: {
      stopColor: "#273168"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04189944,
    style: {
      stopColor: "#29265B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06560032,
    style: {
      stopColor: "#282C62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1012,
    style: {
      stopColor: "#253D77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1441,
    style: {
      stopColor: "#215898"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.176,
    style: {
      stopColor: "#1D70B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    style: {
      stopColor: "#1E6CB1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1976,
    style: {
      stopColor: "#215696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.219,
    style: {
      stopColor: "#244480"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.244,
    style: {
      stopColor: "#26376F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2749,
    style: {
      stopColor: "#282D64"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3182,
    style: {
      stopColor: "#29285D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4385,
    style: {
      stopColor: "#29265B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#29285D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5221,
    style: {
      stopColor: "#282D64"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5379,
    style: {
      stopColor: "#26376F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5507,
    style: {
      stopColor: "#244480"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5616,
    style: {
      stopColor: "#215696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5711,
    style: {
      stopColor: "#1E6CB1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5726,
    style: {
      stopColor: "#1D70B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9218,
    style: {
      stopColor: "#2B317F"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M61.3,68.3h10.1v-3h-4.2l-0.1-3l12.6,0.2l0,2.8h-5l0,12.3l-2.8,0.8l0.2-7l-13.6,0.8c0,0-1.1-7.4,3.9-13 c0,0,4.2-4.9,10.7-4.6c-0.1,0,9.4-0.1,13,9.9l-2.2,0c0,0-3.1-7.1-10.8-7c0,0-5.2-0.3-9.1,4.1C64,61.6,61.6,64.4,61.3,68.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 65.8861,
    y1: 40.3063,
    x2: 80.8429,
    y2: 40.3063
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#29539D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2C4182"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03385266,
    style: {
      stopColor: "#2B3875"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09800667,
    style: {
      stopColor: "#2A2B62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1425,
    style: {
      stopColor: "#29265B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2518,
    style: {
      stopColor: "#2F2C7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2678,
    style: {
      stopColor: "#2E2B76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3177,
    style: {
      stopColor: "#2B2867"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3755,
    style: {
      stopColor: "#29265E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4586,
    style: {
      stopColor: "#29265B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4718,
    style: {
      stopColor: "#273068"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5121,
    style: {
      stopColor: "#234C8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5504,
    style: {
      stopColor: "#2060A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5856,
    style: {
      stopColor: "#1E6CB1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6146,
    style: {
      stopColor: "#1D70B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6279,
    style: {
      stopColor: "#225BA4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6449,
    style: {
      stopColor: "#264894"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6649,
    style: {
      stopColor: "#293B89"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6904,
    style: {
      stopColor: "#2A3382"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7402,
    style: {
      stopColor: "#2B3180"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7981,
    style: {
      stopColor: "#2B317F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8717,
    style: {
      stopColor: "#29265B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9864,
    style: {
      stopColor: "#2B317F"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M73.3,32.5l7.5,15.5c0,0-7.6-4.2-15-0.2L73.3,32.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: -49.1165,
    y1: 159.8077,
    x2: -34.7744,
    y2: 159.8077,
    gradientTransform: "matrix(-1.1077 2.104159e-02 -2.104159e-02 -1.1077 30.1161 278.3856)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01364815,
    style: {
      stopColor: "#2B317F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1283,
    style: {
      stopColor: "#29265B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2969,
    style: {
      stopColor: "#2B317F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3305,
    style: {
      stopColor: "#244F99"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3644,
    style: {
      stopColor: "#1F67AE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3854,
    style: {
      stopColor: "#1D70B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4799,
    style: {
      stopColor: "#29265B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5877,
    style: {
      stopColor: "#29265E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6627,
    style: {
      stopColor: "#2B2867"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7275,
    style: {
      stopColor: "#2E2B76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7482,
    style: {
      stopColor: "#2F2C7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8575,
    style: {
      stopColor: "#29265B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8888,
    style: {
      stopColor: "#292B62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9339,
    style: {
      stopColor: "#293875"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9873,
    style: {
      stopColor: "#294D94"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#29539D"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M73.4,108.7l-8.3-16.3c0,0,8.2,4.3,15.9-0.1L73.4,108.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 58.3171,
    y1: 66.9757,
    x2: 86.6643,
    y2: 66.9757
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1D70B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007834644,
    style: {
      stopColor: "#1E6CB1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01724298,
    style: {
      stopColor: "#2060A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02745893,
    style: {
      stopColor: "#234C8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03818141,
    style: {
      stopColor: "#273168"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04189944,
    style: {
      stopColor: "#29265B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06560032,
    style: {
      stopColor: "#282C62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1012,
    style: {
      stopColor: "#253D77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1441,
    style: {
      stopColor: "#215898"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.176,
    style: {
      stopColor: "#1D70B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    style: {
      stopColor: "#1E6CB1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1976,
    style: {
      stopColor: "#215696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.219,
    style: {
      stopColor: "#244480"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.244,
    style: {
      stopColor: "#26376F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2749,
    style: {
      stopColor: "#282D64"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3182,
    style: {
      stopColor: "#29285D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4385,
    style: {
      stopColor: "#29265B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#29285D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5221,
    style: {
      stopColor: "#282D64"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5379,
    style: {
      stopColor: "#26376F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5507,
    style: {
      stopColor: "#244480"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5616,
    style: {
      stopColor: "#215696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5711,
    style: {
      stopColor: "#1E6CB1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5726,
    style: {
      stopColor: "#1D70B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9218,
    style: {
      stopColor: "#2B317F"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M61.3,68.9h10.1v-3h-4.2l-0.1-3L79.7,63l0,2.8h-5l0,13.1h-2.8l0.2-7l-13.6,0.2c0,0-1.1-6.8,3.9-12.3 c0,0,4.2-4.9,10.7-4.6c-0.1,0,10-0.1,13.6,9.9l-2.8,0c0,0-3.1-7.1-10.8-7c0,0-5.2-0.3-9.1,4.1C64,62.2,61.6,65,61.3,68.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTnd);
export default __webpack_public_path__ + "static/media/TND.c0255ba80efe466d4f5d8e9d692226fd.svg";
export { ForwardRef as ReactComponent };